module.exports = __webpack_public_path__ + "img/Radausflug.5df15f13.svg";